import React from "react";
import { Navigate } from "react-router-dom";
import { getAccessToken } from "../../common/apis";
import { clearSessionCache } from "../../common/session";

const ProtectedRoute = ({ children }) => {
  const token = getAccessToken();
  if (!token) {
    clearSessionCache();
    return <Navigate to="/login" replace />;
  }
  return children;
};

export default ProtectedRoute;
